var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('el-checkbox',{attrs:{"disabled":""},model:{value:(_vm.item.filled),callback:function ($$v) {_vm.$set(_vm.item, "filled", $$v)},expression:"item.filled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }